module.exports = __webpack_public_path__ + "3dc43e74e48a5aa2bba7b8caf41510fc.svg";